import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot } from "vue"

import { reactive, watch, provide } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'TooltipProvider',
  props: {
    openDelay: { default: 0 },
    closeDelay: { default: 0 },
    disabled: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props

const cfg = reactive({
  openDelay: props.openDelay,
  closeDelay: props.closeDelay,
  disabled: props.disabled
})

watch(() => ({ ...props }), p => {
  cfg.openDelay = p.openDelay
  cfg.closeDelay = p.closeDelay
  cfg.disabled = p.disabled
})

provide('tooltipGlobalConfig', cfg)

return (_ctx: any,_cache: any) => {
  return _renderSlot(_ctx.$slots, "default")
}
}

})